export function updateCsrfToken(result: unknown): void {
  const csrfToken = getCsrfTokenFromResult(result);
  setCsrfTokenInLocalStorage(csrfToken);
}

function getCsrfTokenFromResult(result: unknown): string {
  if (typeof result === "object" && result !== null && "csrfToken" in result && typeof result.csrfToken === "string") {
    return result.csrfToken;
  } else {
    throw new Error("The result does not contain a CSRF token.");
  }
}

function setCsrfTokenInLocalStorage(csrfToken: string) {
  localStorage.setItem("csrfToken", csrfToken);
}

export function getCsrfTokenFromLocalStorage(): string {
  return localStorage.getItem("csrfToken") ?? "";
}

export function deleteCsrfTokenFromLocalStorage(): void {
  localStorage.removeItem("csrfToken");
}
